"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getChangedTransforms = exports.editorExport = exports.editorSetPaletteMode = exports.editorAddColor = exports.editorCacheSvg = exports.editorRender = exports.editorTransformed = exports.editorTransform = exports.editorReset = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _download = require("../helpers/download");

var _download2 = _interopRequireDefault(_download);

var _callApiPromise = require("../helpers/call-api-promise");

var _callApiPromise2 = _interopRequireDefault(_callApiPromise);

var _editorRenderer = require("../components/editor/editor-renderer");

var _server = require("react-dom/server");

var _server2 = _interopRequireDefault(_server);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reduce = require("lodash/reduce");

var _reduce2 = _interopRequireDefault(_reduce);

var _isError = require("lodash/isError");

var _isError2 = _interopRequireDefault(_isError);

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

var _icons = require("../reducers/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var EDITOR_USAGE_REPORT_FAILED = "EDITOR_USAGE_REPORT_FAILED";

var editorReset = exports.editorReset = function editorReset() {
    return {
        type: actionTypes.EDITOR_RESET
    };
};

var editorTransform = exports.editorTransform = function editorTransform(transform, data) {
    return function (dispatch, getState) {
        dispatch({
            type: actionTypes.EDITOR_TRANSFORM,
            transform: transform,
            data: data
        });
        dispatch(editorTransformed());
    };
};

var editorTransformed = exports.editorTransformed = function editorTransformed() {
    return function (dispatch, getState) {
        var _getState = getState(),
            editor = _getState.editor;

        dispatch({
            type: actionTypes.EDITOR_TRANSFORMED,
            editor: editor
        });

        var _getState2 = getState(),
            icons = _getState2.icons,
            download = _getState2.download;

        var pendingDownload = download.pendingDownload;

        if (pendingDownload) {
            var iconId = pendingDownload.id;

            var icon = icons[iconId];
            if (icon) {
                var cachedSvg = icon[(0, _icons.makeSvgKey)(_icons.NO_ATTRIBUTION)];
                if (cachedSvg) {
                    dispatch(editorRender(cachedSvg));
                } else {
                    var active_icon = icons.active_icon;

                    if (active_icon && active_icon.id == pendingDownload.id && active_icon.loadingRawSVG == _icons.NO_ATTRIBUTION) {} else {
                        var msg = "Editor transformed but no svg?";
                        console.warn(msg);
                        _raven_client2.default.captureMessage(msg);
                    }
                }
            }
        }
    };
};

// This action takes an icon svg, applies all the transforms in the editor
// reducer to it, rendering the EditorRenderer component to a string.
// Rendering in this fashion avoids embedding user generated content (the icon)
// directly into the DOM
var editorRender = exports.editorRender = function editorRender(svg) {
    return function (dispatch, getState) {
        var _getState3 = getState(),
            editor = _getState3.editor;

        // Having <?xml..?> and <!DOCTYPE> tags in svg is apparently invalid


        var xmlDeclarationRE = /<\?xml(.*?)\?>/gi;
        var docTypeRE = /<!(.*?)>/g;
        // Illustrator adds a switch element with an empty foreignObject
        // with requiredExtensions attribute which trips up PNG export
        var requiredExtensionsRE = /<foreignObject[^<>]*requiredExtensions[^<>]*>[\s\S]*?<\/foreignObject>/;

        // Related to the above, Safari, IE, Edge do not like <switch> tags with no children
        // that explicitly have a truthy requiredFeatures, requiredExtensions or systemLanguage
        // attribute. So just replace switch tags with g's
        svg = svg.replace(/<switch/gi, "<g").replace(/<\/switch>/gi, "</g>");

        [xmlDeclarationRE, docTypeRE, requiredExtensionsRE].forEach(function (re) {
            svg = svg.replace(re, "");
        });

        var renderedSvg = _server2.default.renderToStaticMarkup(_react2.default.createElement(_editorRenderer.UnwrappedEditorRenderer, _extends({}, editor.transforms, { svg: svg })));

        dispatch(editorCacheSvg(renderedSvg));
    };
};

var editorCacheSvg = exports.editorCacheSvg = function editorCacheSvg(svg) {
    return {
        type: actionTypes.EDITOR_CACHE_SVG,
        svg: svg
    };
};
var editorAddColor = exports.editorAddColor = function editorAddColor(color) {
    return {
        type: actionTypes.EDITOR_ADD_COLOR,
        color: color
    };
};
var editorSetPaletteMode = exports.editorSetPaletteMode = function editorSetPaletteMode(mode) {
    return {
        type: actionTypes.EDITOR_SET_PALETTE_MODE,
        mode: mode
    };
};

// For browsers where drawing an SVG to a canvas taints the canvas
// and makes it impossible to export it as SVG.
// Dynamically imports canvg-browser library which implements an SVG
// renderer using the Canvas API
function canvgFallback(svgString, size) {
    return System.import("canvg-browser").then(function (_ref) {
        var canvg = _ref.default;

        var canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;

        canvg(canvas, svgString);

        if (canvas.toBlob) {
            return new Promise(function (resolve, reject) {
                canvas.toBlob(function (blob) {
                    return resolve(blob);
                }, "image/png");
            });
        } else {
            return canvas.toDataURL("image/png");
        }
    });
}

function svgToPng(svgString) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    return new Promise(function (resolve, reject) {
        var DOMURL = self.URL || self.webkitURL || self;
        var img = new Image();
        var svg = new Blob([svgString], {
            type: "image/svg+xml;charset=utf-8"
        });

        var url = DOMURL.createObjectURL(svg);
        img.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            try {
                canvas.toBlob(function (blob) {
                    resolve(blob);
                }, "image/png");
            } catch (e) {

                canvgFallback(svgString, size).then(resolve, reject);
            }
        };
        img.onerror = function (e) {

            canvgFallback(svgString, size).then(resolve, reject);
        };
        img.src = url;
    });
}

var editorExport = exports.editorExport = function editorExport(format, fileName) {
    return function (dispatch, getState) {
        var _getState4 = getState(),
            editor = _getState4.editor;

        var sourceSvg = editor.svg,
            changed = editor.changed;
        var _editor$transforms = editor.transforms,
            exportSize = _editor$transforms.exportSize,
            color = _editor$transforms.color;

        // Check that the editor is actually ready before
        // reporting usage

        var checkSource = new Promise(function (resolve, reject) {
            if (!sourceSvg) {
                console.warn("editor no sourceSvg");
                return reject("Renderer not ready.");
            } else {
                return resolve();
            }
        });

        return checkSource.then(function () {
            return dispatch(editorReport(format));
        }).then(function () {
            fileName = fileName || "icon." + format;

            var downloaded = void 0;
            if (format == "svg") {
                downloaded = (0, _download2.default)(sourceSvg, fileName);
            } else {
                downloaded = svgToPng(sourceSvg, exportSize).then(function (png) {
                    var downloaded = (0, _download2.default)(png, fileName);

                    if (downloaded.then) {
                        return downloaded.then(function () {
                            // png is usually returned as a Blob URL, but IE11 does
                            // not support canvas.toBlob and so returns a dataURL
                            if (png && png.indexOf && png.indexOf("blob") == 0) {
                                var DOMURL = self.URL || self.webkitURL || self;
                                DOMURL.revokeObjectURL(png);
                            }
                        });
                    }
                });
            }

            dispatch({
                type: actionTypes.EDITOR_EXPORT,
                format: format,
                exportSize: exportSize
            });

            downloaded = downloaded.then ? downloaded : Promise.resolve();
            return downloaded.then(function () {
                dispatch({
                    type: actionTypes.EDITOR_EXPORT_SUCCESS,
                    format: format,
                    exportSize: exportSize
                });
            });
        }).catch(function (error) {
            if (error == EDITOR_USAGE_REPORT_FAILED) {
                // This has already been reported to Sentry
                // Create an error to show generic error string to user
                throw new Error(error);
            }

            var msg = void 0;
            if ((0, _isError2.default)(error)) {
                msg = error;
            } else {
                try {
                    msg = JSON.stringify(error);
                } catch (e) {
                    msg = "Unknown error";
                }
            }

            _raven_client2.default.captureException(msg, {
                tags: {
                    impact: "Failed editor export"
                }
            });
            dispatch({
                type: actionTypes.EDITOR_EXPORT_FAILURE,
                format: format,
                exportSize: exportSize,
                error: error
            });
            throw error;
        });
    };
};

var editorReport = function editorReport(format) {
    return function (dispatch, getState) {
        var _getState5 = getState(),
            editor = _getState5.editor,
            download = _getState5.download;

        var transforms = editor.transforms,
            changed = editor.changed;
        var pendingDownload = download.pendingDownload;

        var iconId = void 0;
        if (pendingDownload) {
            iconId = pendingDownload.id;
        } else {
            throw new Error("Editor report failed, no pending download");
        }

        var changedTransforms = getChangedTransforms(changed, transforms);
        var endpoint = "/icon/" + iconId + "/editor/report/";
        return dispatch((0, _callApiPromise2.default)({
            endpoint: endpoint,
            method: "POST",
            data: JSON.stringify({
                type: format,
                changed: changedTransforms
            })
        })).catch(function (error) {
            _raven_client2.default.captureException("Editor usage report failed " + error.status);
            return Promise.reject(EDITOR_USAGE_REPORT_FAILED);
        });
    };
};

var getChangedTransforms = exports.getChangedTransforms = function getChangedTransforms(changed, transforms) {
    return (0, _reduce2.default)(changed, function (acc, transform) {
        acc[transform] = transforms[transform];
        return acc;
    }, {});
};